import FirestoreDocument from "../../../types/FirestoreDocument";
import { array, nullable, object, ref, string } from "../../../types/_types";

const startEndObject = object({
	start: nullable(string()),
	end: nullable(string()),
});

export const User = FirestoreDocument.extend({
	email: string(),
	firstName: string(),
	img: nullable(string()),
	lastName: string(),
	phone: nullable(string()),
	publishers: array(string()),
	calendarAvailability: nullable(
		object({
			1: startEndObject,
			2: startEndObject,
			3: startEndObject,
			4: startEndObject,
			5: startEndObject,
			6: startEndObject,
			7: startEndObject,
		}),
	),
});

export const UserRef = ref(User, {
	email: true,
	firstName: true,
	img: true,
	lastName: true,
	phone: true,
}).transform((data) => {
	const firstName = data.firstName.trim();
	const lastName = data.lastName.trim();

	return {
		...data,
		firstName,
		lastName,
		name: [firstName, lastName].filter((s) => s).join(" "),
	};
});
